import { getEventCategoryByServices } from 'containers/Pages/Events/Layouts';

export const filters = services => {
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'Category',
        field: 'category',
        type: 'select',
        multiple: true,
        options: getEventCategoryByServices(services),
      },
    ],
  };
};
